import { mapState, mapMutations } from 'vuex';

export default {
	computed: {
		...mapState({
			formulateUserProfile: (state) => state.profile.formulateUserProfile,
		}),
	},
	methods: {
		...mapMutations({
			setFormulateUserProfile: 'profile/setFormulateUserProfile',
		}),

		async getFormulateUser(needUpdate = false) {
			if ((this.$auth.loggedIn
				&& !this.formulateUserProfile) || needUpdate
			) {
				const profile = await this.$api.getFormulateProfile();

				this.setFormulateUserProfile(profile);

				return profile;
			}

			return this.formulateUserProfile;
		},
	},
};
